import React, { PureComponent } from 'react';
import { Form } from 'react-final-form';
import Breadcrumb, { BreadcrumbItem } from '../../components/Breadcrumb';
import { createUser, updateUser } from '../../api/users';
import {
  isEmail,
  isRequired,
  isPasswordValid,
} from '../../utils/validation';
import SavingModal from '../../components/SavingModal';
import Loader from '../../atoms/Loader';
import TextField from '../../components/Form/TextField';
import PasswordField from '../../components/Form/PasswordField';
import EmailField from '../../components/Form/EmailField';
import Tabs from '../../components/Tabs';
import SelectArrayField from '../../components/Field/NewSelectArrayField';
import { roleChoices } from '../../utils/constants';

export default class CreateUser extends PureComponent {
  state = {
    loading: false,
    openSavingModal: false,
    error: null,
    userId: null,
    user: null,
  };

  handleSubmit = async (data) => {
    this.setState({ loading: true });

    try {
      if (this.state.userId) {
        await updateUser(this.state.userId, data);
      } else {
        const { id } = await createUser(data);
        this.props.history.replace(`/admin/users/${id}`);
      }
    } catch (e) {
      const error = typeof e.request !== 'undefined'
        ? JSON.parse(e.request.response)
        : e.getMessage;
      this.setState({
        ...this.state,
        error,
      });
    } finally {
      this.setState({
        ...this.state,
        loading: false,
      });
    }
  };

  closeSavingModal = () => this.setState({ openSavingModal: false });

  render() {
    return (
      <>
        <Breadcrumb>
          <BreadcrumbItem to="/admin/users">Utenti</BreadcrumbItem>
          <BreadcrumbItem>Nuovo Utente</BreadcrumbItem>
        </Breadcrumb>

        <Tabs tabs={['User']}/>

        <Form
          onSubmit={this.handleSubmit}
          initialValues={this.state.user || {}}
          render={
            ({ handleSubmit, submitting, pristine}) => (
            <>
              <div className="columns">
                <div className="column is-one-third">
                  <TextField
                    errors={
                      this.state.error
                      && typeof this.state.error.nome !== 'undefined'
                      && this.state.error.nome
                    }
                    name="nome"
                    placeholder="es. Mario Rossi"
                    validate={isRequired}
                    label="Nome"
                  />
                </div>
                <div className="column is-one-third">
                  <TextField
                    errors={
                      this.state.error
                      && typeof this.state.error.username !== 'undefined'
                      && this.state.error.username
                    }
                    name="username"
                    placeholder="es. m.rossi"
                    validate={isRequired}
                    label="Username"
                  />
                </div>
                <div className="column is-one-third">
                  <PasswordField
                    errors={
                      this.state.error
                      && typeof this.state.error.password !== 'undefined'
                      && this.state.error.password
                    }
                    name="password"
                    placeholder="password"
                    validate={isPasswordValid}
                    label="Password"
                  />
                </div>
              </div>
              <div className="columns">
                <div className="column is-one-third">
                  <EmailField
                    errors={
                      this.state.error
                      && typeof this.state.error.email !== 'undefined'
                      && this.state.error.email
                    }
                    name="email"
                    placeholder="es. john@foo.com"
                    validate={isEmail}
                    label="Indirizzo e-mail"
                  />
                </div>
                <div className="column">
                  <SelectArrayField
                    isMulti
                    name="ruoli"
                    label="Ruoli"
                    validate={isRequired}
                    options={roleChoices}
                  />
                </div>
              </div>

              <footer>
                <div className="field">
                  <div className="control">
                    <button
                      type="submit"
                      onClick={handleSubmit}
                      className="button is-orange is-large"
                      disabled={submitting || pristine}
                    >
                      Salva
                    </button>
                  </div>
                </div>
              </footer>
            </>
          )}
        />

        <SavingModal
          isOpen={this.state.openSavingModal}
          onClose={this.closeSavingModal}
        >
          {this.state.user
            && `L'utente "${this.state.user.username}" è stato salvato con successo`}
        </SavingModal>

        {this.state.loading && <Loader/>}
      </>
    );
  }
}
